import { QueryFeature } from '../../../config/queryClient';
import { ClientType } from '../ClientSearch.meta';

enum QueryKey {
  SearchClients = 'SearchClients',
  ClientList = 'ClientList',
}

export const queryKeys = {
  clientListAll: () => [QueryFeature.ClientList],

  searchClients: (term: string) => [QueryFeature.ClientList, QueryKey.SearchClients, term],

  clientList: (term?: string, clientType?: ClientType) => [
    QueryFeature.ClientList,
    QueryFeature.ClientList,
    term,
    clientType,
  ],
};
